import AddEmployeeTable from "./addEmployeeTable.container";

export default AddEmployeeTable;
